/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { ContentAction, Dashboard } from 'common/report/dashboards/types';
import { TemplateEntryPointPath } from 'common/widgets/warning-hero/constants';
import { TileEl, TileImageId } from 'common/components/tile';
import { ContentAdderEl } from '../components/content-adder';
import { ContentAdderTheme } from '../components/content-adder/types';
import { ViewDemoBoardHelpTextEl } from './empty-hero-react';
export function EmptyHero(_ref: {
  dashboard: Dashboard;
  projectId: number;
  workspaceId: number;
  userId: number;
  onOpenFoundationalTemplateModalClicked: (options: {
    entryPoint: TemplateEntryPointPath;
  }) => void;
  onContentAdded?: (content: ContentAction) => void;
}) {
  let {
    dashboard,
    projectId,
    workspaceId,
    userId,
    onOpenFoundationalTemplateModalClicked,
    onContentAdded
  }: {
    dashboard: Dashboard;
    projectId: number;
    workspaceId: number;
    userId: number;
    onOpenFoundationalTemplateModalClicked: (options: {
      entryPoint: TemplateEntryPointPath;
    }) => void;
    onContentAdded?: (content: ContentAction) => void;
  } = _ref;
  return <div sel='.empty-hero' data-sentry-component="EmptyHero" data-sentry-source-file="empty-hero.tsx">
      <ContentAdderEl sel='.content-adder' attrs={{
      'dashboard-info': {
        id: dashboard.id,
        title: dashboard.title
      },
      'project-id': projectId,
      theme: ContentAdderTheme.Primary,
      tooltip: "Add Reports or Text",
      'user-id': userId,
      'workspace-id': workspaceId
    }} on={{
      contentAdded: ev => onContentAdded === null || onContentAdded === void 0 ? void 0 : onContentAdded(ev.detail)
    }} props={{
      customRenderer: () => {
        return <TileEl params={{
          title: _ref2 => {
            let {
              t
            } = _ref2;
            return t("boards.empty-hero.add-report");
          },
          description: _ref3 => {
            let {
              t
            } = _ref3;
            return t("boards.empty-hero.report-description");
          },
          imageId: TileImageId.ADD_REPORT
        }} />;
      }
    }} data-sentry-element="ContentAdderEl" data-sentry-source-file="empty-hero.tsx" />
      <TileEl attrs={{
      elref: "foundationalTemplateAddButton"
    }} params={{
      title: _ref4 => {
        let {
          t
        } = _ref4;
        return t("boards.empty-hero.use-template");
      },
      description: _ref5 => {
        let {
          t
        } = _ref5;
        return t("boards.empty-hero.template-description");
      },
      imageId: TileImageId.START_FROM_TEMPLATE
    }} on={{
      click: () => onOpenFoundationalTemplateModalClicked({
        entryPoint: TemplateEntryPointPath.NewDashboard
      })
    }} data-sentry-element="TileEl" data-sentry-source-file="empty-hero.tsx" />
      <div sel='.break' />
      <ViewDemoBoardHelpTextEl data-sentry-element="ViewDemoBoardHelpTextEl" data-sentry-source-file="empty-hero.tsx" />
    </div>;
}